import { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../config/api";

export default function AuthHeader({ title, subtitle }) {
  const [logo, setLogo] = useState(null);
  const DEFAULT_LOGO = "https://warrantymitra.com/img/logo.png";

  useEffect(() => {
    const domain = window.location.hostname.replace(/^www\./, "");

    const fetchCompanyBranding = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}company/list`,
          { params: { domain } }
        );

        const company = res?.data?.data?.[0];

        // ✅ LOGO
        if (company?.logo) {
          setLogo(company.logo);
        }

        // ✅ BROWSER TAB TITLE (FROM API)
        if (company?.title) {
          document.title = company.title;
        }

      } catch (err) {
        console.error("Branding fetch failed", err);

        // fallback title
        document.title = title || "RR Warranty";
      }
    };

    fetchCompanyBranding();
  }, [title]);

  return (
    // <div className="
    //   text-center mb-6 py-4 rounded-2xl
    //   bg-gradient-to-r from-indigo-600 via-blue-600 to-cyan-500
    //   shadow-lg
    // ">
      <div 
    >
      {/* {logo && ( */}
        <img
          src={logo || DEFAULT_LOGO}
          alt="Company Logo"
          className="mx-auto h-20 mb-2 object-contain"
        />
        <hr className="h-3 text-lg text-slate-950 "/>
      {/* )} */}

      {/* <h1 className="text-2xl font-semibold text-slate-800">
        {title}
      </h1>

      {subtitle && (
        <p className="text-sm text-slate-600">{subtitle}</p>
      )} */}
    </div>
  );
}



// import { useEffect, useState } from "react";
// import axios from "axios";
// import { BASE_URL } from "../../config/api";

// export default function AuthHeader({ title, subtitle }) {
//   const [logo, setLogo] = useState(null);

//   useEffect(() => {
//     const domain = window.location.hostname.replace(/^www\./, "");

//     const fetchLogo = async () => {
//       try {
//         const res = await axios.get(
//           `${BASE_URL}company/list`,
//           { params: { domain } }
//         );

//         const company = res?.data?.data?.[0];

//         if (company?.logo) {
//           setLogo(company.logo);
//         }
//       } catch (err) {
//         console.error("Logo fetch failed", err);
//       }
//     };

//     fetchLogo();
//   }, []);

//   return (
//     <div className="text-center mb-6">
//       {/* Render logo ONLY after API response */}
//       {logo && (
//         <img
//           src={logo}
//           alt="Company Logo"
//           className="mx-auto h-20 mb-2 object-contain"
//         />
//       )}

//       <h1 className="text-2xl font-semibold text-slate-800">{title}</h1>

//       {subtitle && (
//         <p className="text-sm text-slate-600">{subtitle}</p>
//       )}
//     </div>
//   );
// }


// // components/auth/AuthHeader.jsx
// import LogoImg from "../../asset/images/goelectronixB.png";
// import RRLogo from "../../asset/images/rrlogo2.png"

// export default function AuthHeader({ title, subtitle }) {
//   return (
//     <div className="text-center mb-6">
//       {/* <img src={LogoImg} alt="Logo" className="mx-auto h-12 mb-2" /> */}
//       <img src={RRLogo} alt="Logo" className="mx-auto h-25 mb-2" />
//       <h1 className="text-2xl font-semibold text-slate-800">{title}</h1>
//       {subtitle && (
//         <p className="text-sm text-slate-600">{subtitle}</p>
//       )}
//     </div>
//   );
// }
